export const FullScreenLoader = () => (
  <div className='mt-3 text-center'>
    <i className='fa-circle-notch fa-spin fas' />
  </div>
);
